import * as React from "react"

import { cn } from "@/lib/utils"
import { hasOwnHeight, hasSmallTextSize } from "@/components/ui/touch-target"

// Controls that aren't text fields keep their own size on phones.
const NOT_TEXT_TYPES = new Set(["checkbox", "radio", "range", "color", "hidden"])

/**
 * Phones: a 40px field, and 16px text even when the caller passes text-sm,
 * because iOS Safari zooms into any field with smaller text.
 */
const inputTouchClasses = (className: string | undefined, type: string | undefined) =>
  type && NOT_TEXT_TYPES.has(type)
    ? ""
    : cn(!hasOwnHeight(className) && "max-md:h-10", hasSmallTextSize(className) && "max-md:text-base")

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          inputTouchClasses(className, type),
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
